module.exports = __webpack_public_path__ + "img/overSpeed.bfdff30a.svg";